module.exports = __webpack_public_path__ + "img/share.7e1924c5.svg";